import { Pipe, PipeTransform } from '@angular/core';
import { MetaTagsService } from 'src/app/services/meta-tags.service';

@Pipe({
  name: 'twitter'
})
export class TwitterPipe implements PipeTransform {

  constructor(
    private MetaTagsService: MetaTagsService
  ) { }

  transform(link: string, metaData: any): string {
    const pageMetaData = this.MetaTagsService.getPageMetaTags();
    return encodeURI(`https://twitter.com/intent/tweet?text=${pageMetaData?.title}&url=${pageMetaData?.url}`);
  }

}
